import { useState, useEffect } from 'react'
import CsvExportModal from '../../../../../../components/generic/CsvExportModal';


const ExportHierarchyAccount = (props) => {

  const [exportData, setExportData] = useState([]);

  useEffect(() => {
    let tableDataArray = props.tableData;
    if (!tableDataArray || tableDataArray.length < 1) {
      return;
    }
    const newExportData = tableDataArray.map((account) => {
      const unknownValuesAsBlank = (value) =>
        typeof value === "string"
          ? value.replace(/^(unknown)$/i, "")
          : value;

      return {
        "Institution Name": unknownValuesAsBlank(account?.account?.bank?.name),
        "Account Name": unknownValuesAsBlank(account?.description),
        Balance: unknownValuesAsBlank(account?.account?.aggregated_balance),
        Purpose: unknownValuesAsBlank(account?.purpose?.name),
        "Placement": (() => {
          if (!account?.generic_tags || account?.generic_tags?.length === 0) {
            return "";
          }
          return account?.generic_tags?.map(tag => {
            const parts = [];
            if (tag.group && tag.group.name) {
              parts.push(tag.group.name);
            }
            let currentParent = tag.parent;
            const parentNames = [];
            while (currentParent) {
              parentNames.unshift(currentParent.name);
              currentParent = currentParent.parent;
            }
            parts.push(...parentNames);
            parts.push(tag.name);
            return parts.join(' / ');
          }).join(';');
        })(),
        "Connection Status": unknownValuesAsBlank(
          account?.account?.api_connection_status_live ? "Live" : "Not Live"
        ),
        "Holding Entity": unknownValuesAsBlank(account?.beneficiary?.name || account?.entity_name),
        "Account Number Last 4": unknownValuesAsBlank(account?.account?.account_number_last_4),
        "Routing Number": unknownValuesAsBlank(account?.account?.routing_number),
      };
    });

    setExportData(newExportData);
  }, [props.tableData]);


  return (
    <CsvExportModal
      data={exportData}
      fileName={"all-accounts"}
      downloadMessage={"Download information for ### connected account(s)."}
      modalVisible={props.csvModalVisible}
      handleCancelModal={props.handleCancelModal}
    />
  )
}

export default ExportHierarchyAccount